import React from 'react';
import { UserProfile, Client } from '@/shared/types';

interface TemplateProps {
  profile: UserProfile;
  client?: Client | null;
  title: string;
  metaData: { label: string; value: string }[];
  children: React.ReactNode;
  footerNote?: string;
  type: string;
  containerClass: string;
  LogoImage: React.FC<{ size: 'sm' | 'md' | 'lg' | 'xl'; className?: string; light?: boolean }>;
  hideHeader?: boolean;
}

const StartupTemplate: React.FC<TemplateProps> = ({
  profile, client, title, metaData, children, footerNote, type, containerClass, LogoImage, hideHeader = false
}) => {
  return (
    <div className={containerClass}>
       <div className="bg-neutral-50 p-6 m-6 rounded-[2rem] h-full flex flex-col border-4 border-neutral-100">
           {!hideHeader && (
             <>
               <div className="bg-white p-8 rounded-[1.5rem] shadow-sm mb-6 flex justify-between items-center">
                   <div className="flex items-center gap-4">
                       <LogoImage size="md" className="bg-primary-50 rounded-2xl p-2" />
                       <div>
                           <h1 className="font-black text-2xl text-neutral-900 tracking-tight">{profile.name}</h1>
                           <p className="text-primary-600 font-bold text-sm">@{profile.name.replace(/\s+/g, '').toLowerCase()}</p>
                       </div>
                   </div>
                   <div className="text-right">
                       <div className="inline-block bg-neutral-900 text-white px-6 py-2 rounded-full font-bold shadow-lg shadow-slate-200">
                           {type}
                       </div>
                   </div>
               </div>

               <div className="grid grid-cols-2 gap-6 mb-6">
                   <div className="bg-[#f0f9ff] p-8 rounded-[1.5rem] text-info-900">
                       <p className="font-bold opacity-50 uppercase text-xs mb-4">Recipient</p>
                       {client ? (
                           <>
                               <p className="font-bold text-xl">{client.name}</p>
                               <p className="font-medium opacity-70">{client.company}</p>
                               <p className="text-sm mt-2 opacity-60">{client.email}</p>
                           </>
                       ) : <span>No Data</span>}
                   </div>
                   <div className="bg-[#fdf2f8] p-8 rounded-[1.5rem] text-pink-900 flex flex-col justify-center space-y-4">
                       {metaData.map((m, i) => (
                           <div key={i} className="flex justify-between items-center border-b border-pink-200 pb-2 last:border-0 last:pb-0">
                               <span className="font-bold opacity-60 text-xs uppercase">{m.label}</span>
                               <span className="font-bold">{m.value}</span>
                           </div>
                       ))}
                   </div>
               </div>
             </>
           )}

           <div className="bg-white p-8 rounded-[1.5rem] shadow-sm flex-1 startup-table">
               {children}
           </div>

           <div className="text-center mt-6 text-neutral-400 font-bold text-sm">
               {footerNote}
           </div>
       </div>
    </div>
  );
};

export default StartupTemplate;